export default __webpack_public_path__ + "static/media/qzaaklogo.e77f9bd0.png";